import { render, staticRenderFns } from "./ResellerRegistration.vue?vue&type=template&id=01374e70&"
import script from "./ResellerRegistration.vue?vue&type=script&lang=js&"
export * from "./ResellerRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports